import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';
import { register } from 'swiper/element/bundle';
import { environment } from '@env/environment';
import { GAnalyticService } from './core/services/g-analytic.service';

register();

@Component({
  selector: 'ups-root',
  styleUrl: 'app.component.scss',
  templateUrl: 'app.component.html'
})
export class AppComponent {
	
  constructor(
    protected readonly meta: Meta,
    protected readonly platform: Platform,
    protected readonly gAnalytic: GAnalyticService
  ) {
    this.initializeApp();
  }

  protected initializeApp(): void{		    
    this.platform.ready().then(() => {
      this.gAnalytic.init(environment.gAnalyticKey);
      
      this.meta.addTags([
        { name: 'copyright', content: `© ${ (new Date()).getFullYear() } by ${ environment.appname }` },
        { property: 'og:url', content: environment.webDomain },
        { property: 'og:image', content: `${ environment.webDomain }/assets/images/icon.webp` },
        { property: 'twitter:url', content: environment.webDomain },
        { property: 'twitter:image', content: `${ environment.webDomain }/assets/images/icon.webp` }
      ]);


      // Add google ads async
      setTimeout(
        () => {
          const script = document.createElement('script');
          script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js`;
          script.async = script.defer = true;
          document.head.appendChild(script);
        }, 
        500
      );
    });
  }
}
